import React from "react";
import { Link } from "react-router-dom";
import { DEFAULT_LOGO_PROPS } from "../constants/navigation";

interface NavBarLogoProps {
  logoProps?: { src?: string; alt?: string };
}

const NavBarLogo: React.FC<NavBarLogoProps> = ({ logoProps }) => {
  const src = logoProps?.src ?? DEFAULT_LOGO_PROPS.src;
  const alt = logoProps?.alt ?? DEFAULT_LOGO_PROPS.alt;

  return (
    <div className="flex h-full w-1/2 items-center justify-start laptop:w-1/12">
      <Link to="/" className="block cursor-pointer">
        <img src={src} alt={alt} className="h-12 w-auto object-contain md:h-14" />
      </Link>
    </div>
  );
};

export default NavBarLogo;
